<template>
  <div v-loading="isLoading">
    <div class="baseFormDiv">
      <!-- 基础信息 -->
      <el-card class="baseFormCard" shadow="hover">
        <div class="baseFormInner">
          <div class="baseFormLeft">
            <div>
              <viewer v-if="faceObj.imgUrl">
                <img :src="faceObj.imgUrl" style="wdith:auto;height:100px" />
              </viewer>
              <el-avatar v-else :src="circleUrl" :size="50"></el-avatar>
            </div>
            <div class="leftFont">
              <span class="leftTitle">用户信息</span>
            </div>
            <div class="leftBtn">
              <el-button
                size="mini"
                :disabled="notOnLine"
                @click="editBase"
                v-show="!baseObj.isEdit"
              >编辑</el-button>
              <el-button size="mini" type="primary" @click="saveBase" v-show="baseObj.isEdit">保存</el-button>
              <el-button size="mini" @click="cancleBase" v-show="baseObj.isEdit">取消</el-button>
            </div>
          </div>
          <div class="baseFormMiddle">
            <div v-show="baseObj.isEdit">
              <el-form
                :model="baseObj.editForm"
                :rules="rules"
                ref="baseEditForm"
                label-width="130px"
                size="mini"
              >
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="姓名" prop="name">
                      <el-input
                        clearble
                        size="mini"
                        v-model="baseObj.editForm.name"
                        :disabled="noCallEdit"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="农村老人" prop="countryside">
                      <el-radio-group v-model="baseObj.editForm.countryside" :disabled="noCallEdit">
                        <el-radio label="是"></el-radio>
                        <el-radio label="否"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="身份证号" prop="idCard">
                      <el-input
                        clearble
                        size="mini"
                        v-model="baseObj.editForm.idCard"
                        :disabled="noCallEdit"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="居住情况">
                      <el-select v-model="baseObj.editForm.livingConditions">
                        <el-option value="和子女居住" label="和子女居住"></el-option>
                        <el-option value="和老伴居住" label="和老伴居住"></el-option>
                        <el-option value="单独居住" label="单独居住"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="性别">
                      <el-radio-group v-model="baseObj.editForm.gender" :disabled="noCallEdit">
                        <el-radio label="男"></el-radio>
                        <el-radio label="女"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="老人标签">
                      <el-input
                        clearable
                        size="mini"
                        v-model="baseObj.editForm.tagNames"
                        placeholder="老人标签用逗号隔开"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="年龄">
                      <el-input
                        clearble
                        size="mini"
                        v-model="baseObj.editForm.age"
                        :disabled="noCallEdit"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="婚姻情况">
                      <el-select v-model="baseObj.editForm.marriage">
                        <el-option label="已婚" value="已婚"></el-option>
                        <el-option label="未婚" value="未婚"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="出生日期">
                      <el-input
                        clearble
                        size="mini"
                        v-model="baseObj.editForm.dateOfBirth"
                        :disabled="noCallEdit"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="文化程度">
                      <el-select v-model="baseObj.editForm.education">
                        <el-option label="小学" value="小学"></el-option>
                        <el-option label="初中" value="初中"></el-option>
                        <el-option label="高中" value="高中"></el-option>
                        <el-option label="职高" value="职高"></el-option>
                        <el-option label="中专" value="中专"></el-option>
                        <el-option label="大专" value="小学"></el-option>
                        <el-option label="本科" value="本科"></el-option>
                        <el-option label="硕士" value="硕士"></el-option>
                        <el-option label="博士" value="博士"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="民族" prop="nation">
                      <el-select v-model="baseObj.editForm.nation">
                        <el-option
                          v-for="item in nationList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="宗教信仰" prop="religion">
                      <el-input clearable v-model="baseObj.editForm.religion"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="一键通类型" prop="pushToTalkType">
                      <el-select v-model="baseObj.editForm.pushToTalkType" clearable>
                        <el-option label="联通" value="联通"></el-option>
                        <el-option label="电信" value="电信"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item v-show="isTel" label="一键通号码" prop="pushToTalk">
                      <el-input v-model="baseObj.editForm.pushToTalk" key="tel"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="手机号码" prop="phone">
                      <el-input clearble size="mini" v-model="baseObj.editForm.phone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="社保卡号">
                      <el-input clearable size="mini" v-model="baseObj.editForm.sscId"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="座机号码" prop="telephone">
                      <el-input v-model="baseObj.editForm.telephone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4"></el-col>
                </el-row>
                <el-row :span="24" type="flex">
                  <el-col :span="10">
                    <el-form-item label="所属社区" prop="community">
                      <el-cascader
                        v-model="baseObj.editForm.community"
                        :show-all-levels="true"
                        :options="communityList"
                        @change="(val)=>{return selectTree(val,'community')}"
                        :props="communityProps"
                        :disabled="noCallEdit"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="经济来源">
                      <el-input clearable size="mini" v-model="baseObj.editForm.economicSources"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center" class="addressContainer">
                  <el-col :span="10">
                    <el-form-item label="户籍地址" prop="householdRegister">
                      <el-cascader
                        ref="houseHoldSel"
                        v-model="baseObj.editForm.householdRegister"
                        :show-all-levels="true"
                        :options="districtData"
                        @change="(val)=>{return selectTree(val,'houseHold')}"
                        :props="districtProps"
                        :disabled="noCallEdit"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="医疗费支付方式">
                      <el-input clearable size="mini" v-model="baseObj.editForm.medicalPayment"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="户籍详细地址" prop="houseHoldDetail">
                      <el-input
                        :disabled="noCallEdit"
                        type="textarea"
                        v-model="baseObj.editForm.houseHoldDetail"
                        placeholder="长度为5-100个字符"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4"></el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="实际居住地址" prop="residenceAddress">
                      <!-- <el-input clearble size="mini" v-model="baseObj.editForm.residenceAddress"></el-input> -->
                      <el-cascader
                        ref="liveSel"
                        v-model="baseObj.editForm.residenceAddress"
                        :show-all-levels="true"
                        :options="districtData"
                        @change="val=>{return selectTree(val,'residence')}"
                        :props="districtProps"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4"></el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="居住详细地址" prop="residenceDetail">
                      <el-input
                        type="textarea"
                        placeholder="长度为5-100个字符"
                        v-model="baseObj.editForm.residenceDetail"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4"></el-col>
                </el-row>
                <el-row :span="24" type="flex" jutify="center">
                  <el-col :span="10">
                    <el-form-item label="兴趣爱好">
                      <el-input v-model="baseObj.editForm.hobbies"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="饮食禁忌">
                      <el-input v-model="baseObj.editForm.dietTaboo"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" jutify="center">
                  <el-col :span="10">
                    <el-form-item label="血型">
                      <el-select v-model="baseObj.editForm.bloodType">
                        <el-option value="AB" label="AB型"></el-option>
                        <el-option value="A" label="A型"></el-option>
                        <el-option value="B" label="B型"></el-option>
                        <el-option value="O" label="O型"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="身体状况">
                      <el-input v-model="baseObj.editForm.physicalCondition"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" jutify="center">
                  <el-col :span="24">
                    <el-form-item label="备注">
                      <el-input v-model="baseObj.editForm.remark" type="textarea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div v-show="!baseObj.isEdit">
              <el-form
                v-model="baseObj.detailForm"
                ref="baseUserForm"
                label-width="130px"
                size="mini"
              >
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="姓名" prop="shit">
                      <span class="detailInfo">{{baseObj.detailForm.name}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="农村老人">
                      <span class="detailInfo">{{baseObj.detailForm.countryside}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="身份证号" prop="shit">
                      <span class="detailInfo">{{baseObj.detailForm.idCard}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="居住情况">
                      <span class="detailInfo">{{baseObj.detailForm.livingConditions}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="性别" prop="shit">
                      <span class="detailInfo">{{baseObj.detailForm.gender}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="老人标签">
                      <span class="detailInfo">{{baseObj.detailForm.tagNames}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="年龄">
                      <span class="detailInfo">{{baseObj.detailForm.age}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="婚姻情况">
                      <span class="detailInfo">{{baseObj.detailForm.marriage}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="出生日期">
                      <span class="detailInfo">{{baseObj.detailForm.dateOfBirth}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="文化程度">
                      <span class="detailInfo">{{baseObj.detailForm.education}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="民族">
                      <span class="detailInfo">{{baseObj.detailForm.nation}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="宗教信仰">
                      <span class="detailInfo">{{baseObj.detailForm.religion}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="一键通类型" prop="pushToTalkType">
                      <span class="detailInfo">{{baseObj.detailForm.pushToTalkType}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="一键通号码">
                      <span class="detailInfo">{{baseObj.detailForm.pushToTalk}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="座机号码">
                      <span class="detailInfo">{{baseObj.detailForm.telephone}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4"></el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="手机号码">
                      <span class="detailInfo">{{baseObj.detailForm.phone}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="社保卡号">
                      <span class="detailInfo">{{baseObj.detailForm.sscId}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="所属社区">
                      <span class="detailInfo">{{baseObj.detailForm.community}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="经济来源">
                      <span class="detailInfo">{{baseObj.detailForm.economicSources}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="户籍地址">
                      <span class="detailInfo">{{baseObj.detailForm.householdRegister}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="医疗费支付方式">
                      <span class="detailInfo">{{baseObj.detailForm.medicalPayment}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center">
                  <el-col :span="10">
                    <el-form-item label="实际居住地址">
                      <span class="detailInfo">{{baseObj.detailForm.residenceAddress}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="登记时间">
                      <span class="detailInfo">{{baseObj.detailForm.registTime}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" jutify="center">
                  <el-col :span="10">
                    <el-form-item label="兴趣爱好">
                      <span>{{baseObj.detailForm.hobbies}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="饮食禁忌">
                      <span>{{baseObj.detailForm.dietTaboo}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" jutify="center">
                  <el-col :span="10">
                    <el-form-item label="血型">
                      <span>{{baseObj.detailForm.bloodType}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" :offset="4">
                    <el-form-item label="身体状况">
                      <span>{{baseObj.detailForm.physicalCondition}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" jutify="center">
                  <el-col :span="24">
                    <el-form-item label="备注">
                      <span>{{baseObj.detailForm.remark}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :span="24" type="flex" justify="center" v-if="notOnLine">
                  <el-col :span="24">
                    <el-form-item label="老人注销原因">
                      <span>{{baseObj.detailForm.cancelRemark}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div class="baseFormRight"></div>
        </div>
      </el-card>
      <!-- 人脸识别 -->
      <el-card class="baseFormCard" shadow="hover">
        <div class="baseFormInner">
          <div class="baseFormLeft">
            <div class="leftFont">
              <span class="leftTitle">人脸识别登记</span>
            </div>
            <div class="leftBtn">
              <el-button size="mini" :disabled="true" @click="editFace" v-show="!faceObj.isEdit">编辑</el-button>
              <el-button size="mini" type="primary" @click="saveFace" v-show="faceObj.isEdit">保存</el-button>
              <el-button size="mini" @click="cancleFace" v-show="faceObj.isEdit">取消</el-button>
            </div>
          </div>
          <div class="baseFormMiddle">
            <el-form
              v-if="faceObj.isEdit"
              :model="faceObj.editForm"
              label-width="110px"
              size="mini"
            >
              <viewer>
                <img v-if="faceObj.imgUrl" :src="faceObj.imgUrl" class="avatar" />
              </viewer>
              <el-divider></el-divider>
              <el-upload
                v-show="editFaceShow.handShow"
                class="avatar-uploader"
                name="files"
                :action="picUrl"
                :show-file-list="false"
                :on-success="faceUploadSuccess"
                :before-upload="beforeUpload"
              >
                <el-button size="mini" type="primary">手动上传</el-button>
              </el-upload>
              <el-divider></el-divider>
            </el-form>
            <el-form v-else>
              <viewer v-if="faceObj.imgUrl">
                <img style="width:150px" :src="faceObj.imgUrl" />
                <div style="text-align: center;display: inline-block;margin-left: 25%;">
                  <p>人脸照片上传后请立即扫描二维码进行人脸核验</p>
                  <img
                    style="width:150px;display: inline-block;"
                    src="../../../../../assets/faceCheckErcode.png"
                  />
                </div>
              </viewer>
              <span v-else>暂无老人人脸信息</span>
            </el-form>
            <div v-show="editFaceShow.cameraShow">
              <div>
                <el-button
                  @click="openCamera"
                  size="mini"
                  type="primary"
                  v-show="faceObj.isEdit"
                >启动摄像头</el-button>
                <el-button
                  size="mini"
                  type="success"
                  @click="takeFacePhoto"
                  v-show="faceObj.isEdit"
                  :disabled="editFaceShow.takeDisabled"
                >拍照</el-button>
                <div>
                  <canvas style="display:none" id="faceCanvas" width="320" height="240"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div
            class="baseFormRight"
            style="flex:3;display:flex;justify-content:center;align-items:center;flex-flow:column"
          >
            <div>
              <img
                id="tipImg"
                src="../../../../../assets/images/pzsl.jpg"
                style="margin-bottom:10px;display:none;width:240px;height:180px"
              />
            </div>
            <div>
              <video
                id="faceVideo"
                ref="video"
                width="320"
                height="240"
                autoplay
                style="display:none;border:1px solid lightgrey"
              ></video>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 联系人信息 -->
      <el-card class="baseFormCard" shadow="hover">
        <div class="baseFormInner">
          <div class="baseFormLeft">
            <div class="leftFont">
              <span class="leftTitle">联系人信息</span>
            </div>
          </div>
          <div class="baseFormMiddle">
            <div>
              <el-form
                v-for="(item,index) in contactObj.detailContact"
                :key="index"
                size="mini"
                :model="item"
                :rules="contactObj.editRules"
                labelWidth="150px"
                labelPosition="right"
                :ref="index"
              >
                <el-form-item label>
                  <el-button
                    v-if="item.gid&&!item.edit"
                    @click="editOneContact(item)"
                    :disabled="true"
                  >编辑</el-button>
                  <el-button
                    v-if="!item.edit&&item.gid"
                    :disabled="true"
                    type="danger"
                    @click="deleteContact(item,index)"
                  >删除</el-button>
                  <el-button v-if="item.edit" type="primary" @click="saveOneContact(item,index)">保存</el-button>
                  <el-button v-if="item.edit" @click="cancleOneContact(item,index)">取消</el-button>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                  <el-input v-if="item.edit" v-model="item.name"></el-input>
                  <span v-else>{{item.name}}</span>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                  <el-input v-if="item.edit" v-model="item.phone"></el-input>
                  <span v-else>{{item.phone}}</span>
                </el-form-item>
                <el-form-item label="与老人关系" prop="Relationship">
                  <el-select v-if="item.edit" v-model="item.Relationship">
                    <el-option label="子女" value="子女"></el-option>
                    <el-option label="夫妻" value="夫妻"></el-option>
                    <el-option label="亲友" value="亲友"></el-option>
                  </el-select>
                  <span v-else>{{item.Relationship}}</span>
                </el-form-item>
                <el-form-item label="是否是紧急联系人" prop="order">
                  <el-radio-group v-if="item.edit" v-model="item.order">
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                  </el-radio-group>
                  <span v-else>{{item.order}}</span>
                </el-form-item>
                <el-form-item label="人脸照片">
                  <div style="display:flex;flex-flow:row">
                    <!-- <viewer v-if="item.imgUrl">
                      <img :src="item.imgUrl" class="avatar" />
                    </viewer>-->
                    <div style="display:flex;flex-flow:row">
                      <viewer>
                        <img :src="item.imgUrl" class="avatar" />
                      </viewer>
                      <div
                        style="text-align: center;display: inline-block;margin-left: 30px;"
                        v-if="item.gid&&item.imgUrl"
                      >
                        <p>人脸照片上传后请立即扫描二维码进行人脸核验</p>
                        <img
                          style="width:150px;display: inline-block;"
                          src="@/assets/faceCheckErcode.png"
                        />
                      </div>
                    </div>
                  </div>
                  <el-upload
                    class="avatar-uploader"
                    name="files"
                    :data="item.index"
                    :action="picUrl"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>{return handleContactSuccess(response,file,fileList,index)}"
                    :before-upload="beforeUpload"
                  >
                    <el-button v-if="item.edit" size="mini">手动上传</el-button>
                  </el-upload>
                  <el-button
                    v-if="item.edit"
                    @click="openContactCamera"
                    size="mini"
                    type="primary"
                  >启动摄像头</el-button>
                  <el-button
                    v-if="item.edit"
                    size="mini"
                    type="success"
                    @click="takeContactPhoto(item,index)"
                    :disabled="editContactShow.takeDisabled"
                  >拍照</el-button>
                  <div style="display:flex;flex-fow:row">
                    <div>
                      <canvas style="display:none" id="contactCanvas" width="320" height="240"></canvas>
                    </div>
                  </div>
                </el-form-item>
                <el-divider></el-divider>
              </el-form>
              <el-button
                v-if="false"
                size="mini"
                type="success"
                @click="addContact"
                :disabled="noAdd"
                style="margin-left:130px"
              >添加联系人</el-button>
            </div>
          </div>
          <div
            class="baseFormRight"
            style="flex:3;display:flex;justify-content:center;align-items:center;flex-flow:column;position:absolute;top:20vh;left:70%;"
          >
            <div>
              <img
                id="contactTipImg"
                src="../../../../../assets/images/pzsl.jpg"
                style="margin-bottom:10px;display:none;width:240px;height:180px"
              />
            </div>
            <div>
              <video
                id="contactVideo"
                ref="video"
                width="320"
                height="240"
                autoplay
                style="display:none;"
              ></video>
            </div>
          </div>
        </div>
      </el-card>
      <!-- 证件信息 -->
      <el-card class="baseFormCard">
        <div class="baseFormInner">
          <div class="baseFormLeft">
            <div class="leftFont">
              <span class="leftTitle">证件信息</span>
            </div>
            <div class="leftBtn">
              <el-button
                size="mini"
                :disabled="true"
                @click="editPaper"
                v-show="!paperObj.isEdit"
              >编辑</el-button>
              <el-button size="mini" type="primary" @click="savePaper" v-show="paperObj.isEdit">保存</el-button>
              <el-button size="mini" @click="canclePaper" v-show="paperObj.isEdit">取消</el-button>
            </div>
          </div>
          <div class="baseFormMiddle">
            <el-form
              v-if="paperObj.isEdit"
              :model="faceObj.editForm"
              label-width="110px"
              size="mini"
            >
              <el-form-item label="身份证" :required="true">
                <el-upload
                  name="files"
                  class="upload-demo"
                  :action="picUrl"
                  :limit="2"
                  :on-exceed="upLoadLimit"
                  :on-remove="(file)=>{return handleRemove(file,'idCard')}"
                  :on-success="(response,file,fileList)=>{return uploadSuccess(response,file,fileList,'idCard')}"
                  list-type="picture-card"
                  :before-upload="beforeUpload"
                  :file-list="paperObj.idCardEdit"
                >
                  <el-button size="mini" type="text">
                    <i class="el-icon-plus"></i>
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过10M</div>
                </el-upload>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="户口本">
                <el-upload
                  name="files"
                  class="upload-demo"
                  :action="picUrl"
                  :on-remove="(file)=>{return handleRemove(file,'houseHold')}"
                  :on-success="(response,file,fileList)=>{return uploadSuccess(response,file,fileList,'houseHold')}"
                  list-type="picture-card"
                  :before-upload="beforeUpload"
                  :file-list="paperObj.houseEdit"
                >
                  <el-button size="mini" type="text">
                    <i class="el-icon-plus"></i>
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过10M</div>
                </el-upload>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="其他证件">
                <el-upload
                  name="files"
                  class="upload-demo"
                  :action="picUrl"
                  :on-remove="(file)=>{return handleRemove(file,'other')}"
                  :on-success="(response,file,fileList)=>{return uploadSuccess(response,file,fileList,'other')}"
                  list-type="picture-card"
                  :before-upload="beforeUpload"
                  :file-list="paperObj.otherEdit"
                >
                  <el-button size="mini" type="text">
                    <i class="el-icon-plus"></i>
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过10M</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <el-form v-else>
              <el-form-item label="身份证">
                <div style="display:flex;flex-flow:row;padding:20px">
                  <viewer
                    v-for="(item,index) in paperObj.idCardImgList"
                    style="margin-left:20px"
                    :key="index"
                  >
                    <img :src="item" class="paperImg" />
                  </viewer>
                </div>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="户口本">
                <div style="display:flex;flex-flow:row;padding:20px">
                  <viewer
                    v-for="(item,index) in paperObj.houseImgList"
                    style="margin-left:20px"
                    :key="index"
                  >
                    <img :src="item" class="paperImg" />
                  </viewer>
                </div>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="其他证件">
                <div style="display:flex;flex-flow:row;padding:20px">
                  <viewer
                    v-for="(item,index) in paperObj.otherImgList"
                    style="margin-left:20px"
                    :key="index"
                  >
                    <img :src="item" class="paperImg" />
                  </viewer>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="baseFormRight" style="flex:3">
            <div></div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import dataApi from "../../_api/api";
import {
  olderFace,
  delContact,
  addContact,
  editContact,
  editOlderBase,
  getDistrict
} from "@/services/all-api.js";
import { mkdir, stat } from "fs";
import { post, put } from "@/config/httpConfig";
import { constants } from "crypto";
import { setTimeout } from "timers";
import { loadavg } from "os";
import { mapState } from "vuex";
import elTreeDistrict from "@/utils/district.js";

export default {
  inject: ["reload"],
  data() {
    let isPhone = this.$filter.isPhone;
    let isIDCard = this.$filter.isIDCard;
    let isNumber = this.$filter.isNumber;
    return {
      noAdd: false,
      isTel: null,
      districtData: elTreeDistrict,
      communityProps: {
        label: "name",
        children: "districts",
        value: "name"
      },
      districtProps: {
        label: "name",
        children: "districts",
        value: "name"
      },
      districtProps: {
        label: "name",
        children: "districts",
        value: "name",
        lazy: true,
        lazyLoad(node, resolve) {
          var that = this;
          const { level } = node;
          if (node.data.adCode === "620200") {
            resolve();
            return false;
          } else if (node.level === 3) {
            const reqObj = {
              keywords: node.data.adCode,
              subdistrict: 1
            };
            getDistrict(reqObj).then(res => {
              let data = res.data[0].districts;
              const nodes = data.map((item, index) => ({
                name: item.name,
                adCode: item.adCode,
                leaf: true
              }));
              resolve(nodes);
            });
          } else {
            resolve();
          }
        }
      },
      noCallEdit: true,
      isLoading: false,
      faceCameraStream: "",
      contactCameraStream: "",
      tempFaceImg: "",
      showCamera: false,
      baseData: "",
      baseOrigin: "",
      nationList: this.$xiaLaList.getNation(),
      communityList: [],
      picUrl: "/api/picture",
      relationList: this.$xiaLaList.getRelationSel(),
      editContactIndex: "",
      saveContactBtnShow: false,
      baseObj: {
        isEdit: false,
        detailForm: {
          name: "",
          countryside: "",
          idCard: "",
          livingConditions: "",
          gender: "",
          tagNames: "",
          age: "",
          dateOfBirth: "",
          phone: "",
          community: "",
          householdRegister: "", //户籍地址
          residenceAddress: "", //实际居住地址
          education: "",
          marriage: "",
          sscId: "",
          economicSources: "",
          medicalPayment: "",
          registTime: "",
          hobbies: "",
          dietTaboo: "",
          bloodType: "",
          physicalCondition: "",
          remark: "",
          pushToTalk: "",
          pushToTalkType: ""
        },
        editForm: {
          name: "dudidi",
          countryside: "",
          idCard: "",
          livingConditions: "",
          gender: "",
          tagNames: "",
          age: "",
          dateOfBirth: "",
          phone: "",
          community: "",
          householdRegister: "", //户籍地址
          residenceAddress: "", //实际居住地址
          education: "",
          marriage: "",
          sscId: "",
          economicSources: "",
          medicalPayment: "",
          registTime: "",
          hobbies: "",
          dietTaboo: "",
          bloodType: "",
          physicalCondition: "",
          remark: "",
          pushToTalk: "",
          pushToTalkType: ""
        }
      },
      rules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        idCard: [
          {
            required: true,
            validator: isIDCard,
            trigger: "blur"
          }
        ],
        phone: [
          {
            validator: this.$filter.notRerquiredPhone,
            trigger: "blur"
          }
        ],
        nation: [{ required: true, message: "请选择民族", trigger: "change" }],
        pushToTalk: [{}],
        community: [
          { required: true, message: "社区不能为空", trigger: "change" }
        ],
        householdRegister: [
          { required: true, message: "户籍地址不能为空", trigger: "blur" }
        ],
        houseHoldDetail: [
          { required: true, message: "户籍详细地址不能为空", trigger: "blur" },
          {
            min: 5,
            max: 100,
            message: "请输入正确的户籍详细地址",
            trigger: "change"
          }
        ],
        residenceAddress: [
          { required: true, message: "实际居住地址不能为空", trigger: "blur" }
        ],
        residenceDetail: [
          { required: true, message: "居住详细地址不能为空", trigger: "blur" },
          {
            min: 5,
            max: 100,
            message: "请输入正确的居住详细地址",
            trigger: "change"
          }
        ],
        countryside: [
          {
            required: true,
            message: "选择是否是农村老人",
            trigger: "change"
          }
        ],
        sscId: {
          validator: isNumber,
          trigger: "blur"
        }
      },
      editFaceShow: {
        handShow: true,
        cameraShow: true,
        takeDisabled: true
      },
      editContactShow: {
        handShow: true,
        cameraShow: true,
        takeDisabled: true
      },
      faceObj: {
        isEdit: false,
        url: "/api/picture",
        previewVisible: false,

        imgUrl: ""
      },
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      contactObj: {
        isEdit: true,
        detailContact: [],
        editContact: [],
        editRules: {
          name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
          phone: [
            {
              required: true,
              validator: isPhone,
              trigger: "blur"
            }
          ],
          Relationship: [
            { required: true, message: "选择关系", trigger: "change" }
          ]
        }
      },
      contactSpan: false,
      paperObj: {
        isEdit: false,
        idCardImgList: [],
        houseImgList: [],
        otherImgList: [],
        idCardEdit: [],
        houseEdit: [],
        otherEdit: []
      }
    };
  },
  computed: {
    ...mapState(["oneOlder"]),
    idCard() {
      return this.baseObj.editForm.idCard;
    },
    notOnLine() {
      return this.oneOlder.status !== 0;
    },
    pushToTalkType() {
      return this.baseObj.editForm.pushToTalkType;
    }
  },
  watch: {
    idCard(i, j) {
      const obj = this.$getInfoFromId.getMessageByIdCard(i);
      if (obj) {
        this.baseObj.editForm.dateOfBirth = obj.birthStr;
        this.baseObj.editForm.age = obj.age;
        this.baseObj.editForm.gender = obj.sex;
      } else if (!obj) {
        this.baseObj.dateOfBirth = "";
        this.baseObj.editFormage = "";
        this.baseObj.editForm.gender = "";
      }
    },
    pushToTalkType(i, j) {
      if (!i) {
        this.$refs.baseEditForm.clearValidate("pushToTalk");
        this.isTel = false;
        this.baseObj.editForm.pushToTalk = "";
        this.rules.pushToTalk = [{}];
      } else {
        this.rules.pushToTalk = [
          { required: true, message: "请输入一键通号码", trigger: "blur" }
        ];
        this.isTel = true;
      }
    }
  },
  methods: {
    editOneContact(i) {
      this.contactObj.detailContact = this.contactObj.detailContact.map(item => {
        if (i.gid === item.gid) {
          return ({ ...item, edit: true, noEdit: false })
        } else {
          return ({ ...item, noEdit: true })
        }
      })
    },
    cancleOneContact(item, idx) {
      this.contactObj.detailContact = this.contactObj.detailContact.map(item => {
        return ({ ...item, noEdit: false, edit: false })
      })
      if (!Boolean(item.gid)) {
        this.contactObj.detailContact.splice(idx, 1);
        this.noAdd = false
      }
      this.editContactShow.takeDisabled = true;
      this.contactObj.detailContact = JSON.parse(
        sessionStorage.getItem("contactData")
      );
      document.getElementById("contactVideo").style.display = "none";
      document.getElementById("contactTipImg").style.display = "none";
      this.contactCameraStream && this.contactCameraStream.stop();
      //清除表单验证
      for (var i in this.$refs) {
        if (!isNaN(i)) {
          this.$refs[i][0].resetFields()
        }
      }
    },
    saveOneContact(item, index) {
      let Flag = 1;
      for (var i in this.$refs) {
        if (!isNaN(i)) {
          this.$refs[i][0].validate(valid => {
            if (valid) {
            } else if (!valid) {
              Flag = 0;
            }
          });
        }
      }
      if (Flag === 1) {
        if (item.gid) {
          const obj = {
            name: item.name,
            phone: item.phone,
            order: item.order === '是' ? 1 : 0,
            picture: item.imgUrl || '',
            gid: item.gid,
            Relationship: item.Relationship
          }
          let loading = this.$loading({
            lock: true,
            text: "提交中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          editContact(obj).then(
            res => {
              if (res.code === 0) {
                this.$message.success('联系人编辑成功')
                this.contactCameraStream && this.contactCameraStream.stop();
                document.getElementById("contactVideo").style.display = "none";
                this.reload()
              } else {
                this.$message.error(`编辑失败:${res.des}`)
              }
            }
          ).finally(() => {
            loading.close()
          })
        } else {
          const obj = {
            name: item.name,
            phone: item.phone,
            order: item.order === '是' ? 1 : 0,
            picture: item.imgUrl || '',
            theoldgid: this.oneOlder.theOldGid,
            Relationship: item.Relationship
          }
          let loading = this.$loading({
            lock: true,
            text: "提交中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          addContact(obj).then(
            res => {
              if (res.code === 0) {
                this.$message.success('联系人添加成功')
                this.contactCameraStream && this.contactCameraStream.stop();
                document.getElementById("contactVideo").style.display = "none";
                this.reload()
              } else {
                this.$message.error(`添加失败:${res.des}`)
              }
            }
          ).finally(() => {
            loading.close()
          })
        }
      } else {
        return false
      }
    },
    selectTree(val, type) {
      if (type === "houseHold") {
        this.houseHoldReq = val.join(" ");
      }
      if (type === "residence") {
        this.residenceReq = val.join(" ");
      }
      if (type === "community") {
        this.communityReq = val.join(" ");
      }
    },
    getAll() {
      this.isLoading = true;
      let obj = {
        gid: this.oneOlder.theOldGid
      };
      dataApi
        .getAllInfo(obj)
        .then(res => {
          this.isLoading = false;
          const item = res.base.data;
          const contact = res.contact.data;
          if (contact.length === 0) {
            this.contactSpan = true;
          }
          const oneOldDetail = {
            ...this.oneOlder,
            status: item.status
          };
          this.$store.commit("SET_ONEOLDER", oneOldDetail);
          const originObj = {
            name: item.name || "",
            countryside: item.countryside === true ? "是" : "否" || "",
            idCard: item.idCard || "",
            livingConditions: item.livingConditions || "",
            gender: item.gender == true ? "男" : "女",
            tagNames: item.tagNames || "",
            age: item.age || "",
            nation: item.nation,
            dateOfBirth: item.dateOfBirth || "",
            phone: item.phone || "",
            community: item.community,
            householdRegister: item.householdRegister,
            residenceAddress: item.residenceAddress,
            education: item.education || "",
            marriage: item.marriage || "",
            sscId: item.sscId || "",
            economicSources: item.economicSources || "",
            medicalPayment: item.paymentOfMedicalExpenses || "",
            religion: item.religion,
            registTime: item.createTime || "",
            hobbies: item.hobbies,
            dietTaboo: item.dietTaboo || "",
            bloodType: item.bloodType || "",
            physicalCondition: item.physicalCondition || "",
            remark: item.remark || "",
            picture: item.picture || "",
            idCardList: item.idCardPicture,
            houseList: item.residenceBookletPicture,
            otherList: item.otherCredentialPicture,
            cancelRemark: item.cancelRemark,
            pushToTalkType: item.pushToTalkType || "",
            pushToTalk: item.pushToTalk || "",
            telephone: item.telephone || ""
          };
          sessionStorage.setItem("baseData", JSON.stringify(originObj));
          const tempOrigin = JSON.parse(sessionStorage.getItem("baseData"));
          this.baseObj.detailForm = {
            ...tempOrigin,
            pushToTalkType: tempOrigin.pushToTalkType || "-",
            pushToTalk: tempOrigin.pushToTalk || "-"
          };
          this.baseObj.detailForm.hobbies = "";
          this.faceObj.imgUrl = tempOrigin.picture;
          this.baseObj.editForm = tempOrigin;
          this.baseObj.detailForm = tempOrigin;
          this.paperObj.idCardImgList = !tempOrigin.idCardList
            ? []
            : tempOrigin.idCardList.split(",");
          this.paperObj.houseImgList = !tempOrigin.houseList
            ? []
            : tempOrigin.houseList.split(",");
          this.paperObj.otherImgList = !tempOrigin.otherList
            ? []
            : tempOrigin.otherList.split(",");
          let obj = contact.map((item, index) => ({
            name: item.name,
            Relationship: item.relationship,
            phone: item.phone,
            order: item.order === 1 ? "是" : "否",
            imgUrl: item.picture,
            gid: item.gid
          }));
          sessionStorage.setItem("contactData", JSON.stringify(obj));
          this.contactObj.detailContact = JSON.parse(
            sessionStorage.getItem("contactData")
          ).map(item => ({ ...item, edit: false, noEdit: false }));
        })
        .catch(() => {
          this.isLoading = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //基础信息
    editBase() {
      this.baseObj.isEdit = true;
      const obj = JSON.parse(sessionStorage.getItem("baseData"));
      let hujiAddress = this.$baseFunc
        .charSub(obj.householdRegister)
        .front.split(" ");
      let liveAddress = this.$baseFunc
        .charSub(obj.residenceAddress)
        .front.split(" ");
      this.baseObj.editForm = {
        ...obj,
        community: obj.community.split(" "),
        householdRegister: hujiAddress,
        residenceAddress: liveAddress,
        houseHoldDetail: this.$baseFunc.charSub(obj.householdRegister).after,
        residenceDetail: this.$baseFunc.charSub(obj.residenceAddress).after
      };
      this.$refs.houseHoldSel.inputValue = hujiAddress.join(" / ");
      this.$refs.houseHoldSel.presentText = hujiAddress.join(" / ");
      this.$refs.houseHoldSel.checkedValue = hujiAddress;
      this.$refs.liveSel.inputValue = liveAddress.join(" / ");
      this.$refs.liveSel.presentText = liveAddress.join(" / ");
      this.$refs.liveSel.checkedValue = liveAddress;
    },
    saveBase() {
      this.$refs.baseEditForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "提交中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          const temp = this.baseObj.editForm;
          const origin = JSON.parse(sessionStorage.getItem("baseData"));
          const reqObj = {
            gid: this.oneOlder.theOldGid,
            name: temp.name || "",
            phone: temp.phone || "",
            idCard: temp.idCard || "",
            gender: temp.gender == "男" ? true : false,
            nation: temp.nation || "",
            community: `${temp.community.join(" ")}`,
            householdregister: `${temp.householdRegister.join(" ")}-${
              temp.houseHoldDetail
              }`,
            residenceAddress: `${temp.residenceAddress.join(" ")}-${
              temp.residenceDetail
              }`,
            countryside: temp.countryside == "是" ? true : false,
            livingConditions: temp.livingConditions || "",
            tagNames: temp.tagNames || "",
            religion: temp.religion || "",
            education: temp.education || "",
            marriage: temp.marriage || "",
            economicSources: temp.economicSources || "",
            sscid: temp.sscId || "",
            paymentOfMedicalExpenses: temp.medicalPayment || "",
            hobbies: temp.hobbies || "",
            dietTaboo: temp.dietTaboo || "",
            bloodType: temp.bloodType || "",
            remark: temp.remark || "",
            physicalcondition: temp.physicalCondition || "",
            picture: origin.picture,
            idCardPicture: origin.idCardList,
            residenceBookletPicture: origin.houseList,
            otherCredentialPicture: origin.otherList,
            pushToTalk: temp.pushToTalk || "",
            pushToTalkType: temp.pushToTalkType || "",
            telephone: temp.telephone || ""
          };
          editOlderBase(reqObj)
            .then(res => {
              loading.close();
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: "更新成功"
                });
                this.baseObj.isEdit = false;
                this.$router.go(-1)
                // this.reload();
              } else {
                this.$message({
                  type: "error",
                  message: "老人基础信息更新失败"
                });
              }
            })
            .finally(() => {
              loading.close();
            });
        } else {
          return false;
        }
      });
    },
    cancleBase() {
      var that = this;
      that.baseObj.isEdit = false;
      this.$set(
        this.baseObj.detailForm,
        JSON.parse(sessionStorage.getItem("baseData"))
      );
    },
    //人脸识别
    editFace() {
      this.faceObj.isEdit = true;
      this.faceObj.imgUrl = this.faceObj.imgUrl || "";
    },
    cancleFace() {
      this.faceObj.isEdit = false;
      this.faceObj.imgUrl = JSON.parse(
        sessionStorage.getItem("baseData")
      ).picture;
      document.getElementById("faceVideo").style.display = "none";
      document.getElementById("tipImg").style.display = "none";
      this.faceCameraStream && this.faceCameraStream.stop();
      this.editFaceShow.takeDisabled = true;
    },
    saveFace() {
      if (!this.faceObj.imgUrl) {
        this.$message({
          type: "error",
          message: "人脸照片不能为空!"
        });
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "提交中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const reqObj = {
        theoldgid: this.oneOlder.theOldGid,
        picture: this.faceObj.imgUrl
      };
      olderFace(reqObj)
        .then(res => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "老人人脸信息提交成功!"
            });
            this.faceCameraStream && this.faceCameraStream.stop();
            document.getElementById("faceVideo").style.display = "none";
            document.getElementById("tipImg").style.display = "none";
            this.reload();
          } else {
            this.$message({
              type: "error",
              message: `老人人脸信息提交失败:${res.des}`
            });
          }
        })
        .catch(() => {
          loading.close();
        })
        .finally(() => {
          loading.close();
        });
    },
    editPaper() {
      this.paperObj.isEdit = true;
      this.paperObj.idCardEdit = this.paperObj.idCardImgList.map(
        (item, index) => ({ url: item })
      );
      this.paperObj.houseEdit = this.paperObj.houseImgList.map(
        (item, index) => ({ url: item })
      );
      this.paperObj.otherEdit = this.paperObj.otherImgList.map(
        (item, index) => ({ url: item })
      );
    },
    canclePaper() {
      this.paperObj.isEdit = false;
    },
    faceUploadSuccess(response, file, fileList) {
      this.faceObj.imgUrl = response.data[0];
    },
    //身份证  户口本  其他证件等的上传
    uploadSuccess(response, file, fileList, j) {
      let tempObj = {
        url: response.data[0],
        uid: file.uid
      };
      if (j === "idCard") {
        this.paperObj.idCardEdit.push(tempObj);
      }
      if (j === "houseHold") {
        this.paperObj.houseEdit.push(tempObj);
      }
      if (j === "other") {
        this.paperObj.otherEdit.push(tempObj);
      }
    },
    handleRemove(file, j) {
      if (j === "idCard") {
        this.paperObj.idCardEdit = this.paperObj.idCardEdit.filter(item => {
          return !(item.uid === file.uid);
        });
      }
      if (j === "houseHold") {
        this.paperObj.houseEdit = this.paperObj.houseEdit.filter(item => {
          return !(item.uid === file.uid);
        });
      }
      if (j === "other") {
        this.paperObj.otherEdit = this.paperObj.otherEdit.filter(item => {
          return !(item.uid === file.uid);
        });
      }
    },
    beforeUpload(file) {
      return this.$baseFunc.beforeImgUpload(file);
    },
    //联系人人脸上传
    handleContactSuccess(response, file, fileList, index) {
      this.contactObj.detailContact[index].imgUrl = response.data[0];
    },
    upLoadLimit(file, fileList) {
      this.$message({
        type: "error",
        message: "超出上传图片张数限制"
      });
    },
    //联系人信息
    editContact() {
      let arr = JSON.parse(sessionStorage.getItem("contactData"));
      this.contactObj.editContact = arr;
      this.contactSpan = false;
      this.$nextTick().then(() => {
        this.contactObj.isEdit = true;
      });
    },
    addContact() {
      this.contactObj.detailContact = this.contactObj.detailContact.map((item, index) => {
        return ({ ...item, edit: false, noEdit: true })
      })
      this.contactObj.detailContact.push({
        name: "",
        phone: "",
        imgUrl: "",
        order: "否",
        Relationship: "",
        edit: true,
        noEdit: false
      });
      this.noAdd = true
    },
    deleteContact(item, i) {
      if (item.gid) {
        this.$confirm("此操作将永久删除该联系人, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error"
        })
          .then(() => {
            const loading = this.$loading({
              lock: true,
              text: "删除中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            const reqObj = {
              gid: item.gid
            };
            delContact(reqObj)
              .then(res => {
                loading.close();
                if (res.code == 0) {
                  this.$message({
                    type: "success",
                    message: "删除成功"
                  });
                  this.reload();
                } else {
                  this.$message({
                    type: "error",
                    message: "删除失败"
                  });
                }
              })
              .catch(() => {
                loading.close();
              });
          })
          .catch(() => { });
      }
    },
    savePaper() {
      if (this.paperObj.idCardEdit && this.paperObj.idCardEdit.length === 0) {
        this.$message({
          type: "error",
          message: "身份证照片不能为空!"
        });
        return false;
      }
      const temp = JSON.parse(sessionStorage.getItem("baseData"));
      const reqObj = {
        gid: this.oneOlder.theOldGid,
        name: temp.name || "",
        phone: temp.phone || "",
        idCard: temp.idCard || "",
        gender: temp.gender == "男" ? true : false,
        nation: temp.nation || "",
        community: temp.community || "",
        householdregister: temp.householdRegister || "",
        residenceAddress: temp.residenceAddress || "",
        countryside: temp.countryside == "是" ? true : false,
        livingConditions: temp.livingConditions || "",
        householdregister: temp.householdRegister || "",
        tagNames: temp.tagNames || "",
        religion: temp.religion || "",
        education: temp.education || "",
        marriage: temp.marriage || "",
        economicSources: temp.economicSources || "",
        sscid: temp.sscId || "",
        paymentOfMedicalExpenses: temp.paymentOfMedicalExpenses || "",
        hobbies: temp.hobbies || "",
        dietTaboo: temp.dietTaboo || "",
        bloodType: temp.bloodType || "",
        remark: temp.remark || "",
        physicalcondition: temp.physicalcondition || "",
        picture: temp.picture,
        idcardpicture: this.paperObj.idCardEdit.map(item => item.url).join(","),
        residencebookletpicture: this.paperObj.houseEdit
          .map(item => item.url)
          .join(","),
        othercredentialpicture: this.paperObj.otherEdit
          .map(item => item.url)
          .join(",")
      };
      const loading = this.$loading({
        lock: true,
        text: "提交中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      editOlderBase(reqObj)
        .then(res => {
          loading.close();
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "更新成功"
            });
            this.baseObj.isEdit = false;
            this.reload();
          } else {
            this.$message({
              type: "error",
              message: "更新失败"
            });
          }
        })
        .catch(() => {
          loading.close();
        })
        .finally(() => {
          loading.close();
        });
    },
    //其它信息
    editOther() {
      this.otherObj.isEdit = true;
    },
    cancleOther() {
      this.otherObj.isEdit = false;
    },
    getVideo() {
      this.$nextTick(() => {
        var video = this.$refs.video; //这个对应的是ref属性
        var videoObj = { video: true };
        navigator.mediaDevices
          .getUserMedia(videoObj)
          .then(function (mediaStream) {
            video.srcObject = mediaStream;
            video.play();
          })
          .catch(function (error) { });
      });
    },
    openCamera() {
      let constraints = {
        video: true
      };
      var that = this;
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (mediaStream) {
          that.showCamera = true;
          that.faceCameraStream = mediaStream.getTracks()[0];
          var video = document.getElementById("faceVideo");
          document.getElementById("tipImg").style.display = "block";
          video.style.display = "block";
          video.srcObject = mediaStream;
          video.onloadedmetadata = function (e) {
            video.play();
          };
          that.editFaceShow.takeDisabled = false;
        })
        .catch(() => { });
    },
    openContactCamera() {
      let constraints = {
        video: true
      };
      var that = this;
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (mediaStream) {
          that.contactCameraStream = mediaStream.getTracks()[0];
          that.showCamera = true;
          var video = document.getElementById("contactVideo");
          document.getElementById("contactTipImg").style.display = "block";
          video.style.display = "block";
          video.srcObject = mediaStream;
          video.onloadedmetadata = function (e) {
            video.play();
          };
          that.editContactShow.takeDisabled = false;
        })
        .catch(() => { });
    },
    takeFacePhoto() {
      var outrec = document.getElementById("faceCanvas");
      var outreccon = outrec.getContext("2d");
      let video = document.getElementById("faceVideo");
      outreccon.drawImage(video, 0, 0, 320, 240);
      var img = outrec.toDataURL("/image/jpeg", 0.5);
      this.tempFaceImg = img;
      const obj = {
        image: this.tempFaceImg
      };
      put("/api/picture", obj).then(res => {
        if (res.code === 0) {
          this.faceObj.imgUrl = res.data;
        } else {
          this.$message({
            type: "error",
            message: `图片上传失败:${res.des}`
          });
        }
      });
    },
    takeContactPhoto(item, idx) {
      var outrec = document.getElementById("contactCanvas");
      var outreccon = outrec.getContext("2d");
      let video = document.getElementById("contactVideo");
      outreccon.drawImage(video, 0, 0, 320, 240);
      var img = outrec.toDataURL("/image/jpeg", 0.5);
      this.contactObj.detailContact[idx].imgUrl = img;
      const obj = {
        image: img
      };
      put("/api/picture", obj).then(res => {
        if (res.code === 0) {
          this.contactObj.detailContact[idx].imgUrl = res.data;
        } else {
          this.$message({
            type: "error",
            message: `图片上传失败:${res.des}`
          });
        }
      });
    }
  },
  mounted() {
    sessionStorage.removeItem("baseData");
    sessionStorage.removeItem("contactData");
    this.getAll();
    this.$xiaLaList.getCommunityList().then(res => {
      this.communityList = res;
    });
  },
  beforeDestroy() {
    sessionStorage.removeItem("baseData");
    sessionStorage.removeItem("contactData");
  }
};
</script>

<style lang="scss" scoped>
.paperImg {
  height: 160px;
  width: auto;
}
//老人 基础信息详情 表单样式
.baseFormDiv {
  display: flex;
  width: 100%;
  flex-flow: column;
  .baseFormCard {
    margin-top: 15px;
    width: 100%;
  }
  .baseFormInner {
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    .baseFormLeft {
      flex: 1;
      display: flex;
      flex-flow: column;
      align-items: center;
      .leftFont {
        margin-top: 15px;
        .leftTitle {
          font-weight: bold;
        }
      }
      .leftBtn {
        margin-top: 10px;
      }
    }
    .baseFormMiddle {
      flex: 5;
    }
    .baseFormRight {
      flex: 1;
    }
  }
}
//人脸图片
.faceImgContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  .imgNameDiv {
    span {
      color: gray;
      font-size: 12px;
      font-family: "Helvetica Neue", Helvetica, "PingFang SC",
        "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }
  }
}
</style>
